// ユーザー招待画面
$(() => {
    if (document.getElementById('client-user-invite') != null) {
        $('.js-send').on('click', function(e) {
            $('#invite-form').submit();
            $('#confirmModal').modal('hide');
        });
    }
});
